// Roles page — add / edit / delete handlers using Dialog + Toast plugins.

(function ($) {
  'use strict';

  if ($('#role-tbody').length === 0) return;

  var BTN_PRIMARY = 'bg-orange-500 hover:bg-orange-600 text-white';
  var BTN_DANGER  = 'bg-red-500 hover:bg-red-600 text-white';

  function readForm() {
    return {
      name: $('#role-name').val().trim(),
      description: $('#role-description').val().trim(),
    };
  }

  function patchRow($row, fields) {
    $.each(fields, function (key, value) {
      $row.find('.row-' + key).text(value);
    });
  }

  // ---------- Add ----------
  $(document).on('click', '.role-add-btn', function () {
    $.get('/api/roles/modal/add/', function (resp) {
      if (!resp.ok) { Toast.show(resp.error || 'Failed', 'error'); return; }
      var dlg = new Dialog('Add role', resp.html, { size: 'md' });
      dlg.setButtons([
        { name: 'Cancel', dismiss: true },
        {
          name: 'Create',
          class: BTN_PRIMARY,
          onClick: function () {
            var lb = new LoadingButton(this); lb.start();
            $.post('/api/roles/add/', readForm())
              .done(function (r) {
                if (r.ok) {
                  $('#role-tbody').prepend(r.row_html);
                  Toast.show('Role created', 'success');
                  dlg.hide();
                } else {
                  Toast.show(r.error || 'Failed', 'error');
                  lb.stop('Create');
                }
              })
              .fail(function (xhr) {
                Toast.show((xhr.responseJSON && xhr.responseJSON.error) || 'Request failed', 'error');
                lb.stop('Create');
              });
          },
        },
      ]).show();
    });
  });

  // ---------- Edit ----------
  $(document).on('click', '.role-edit-btn', function () {
    var $row = $(this).closest('tr');
    var id = $row.data('id');
    $.get('/api/roles/modal/update/', { id: id }, function (resp) {
      if (!resp.ok) { Toast.show(resp.error || 'Failed', 'error'); return; }
      var dlg = new Dialog('Edit role', resp.html, { size: 'md' });
      dlg.setButtons([
        { name: 'Cancel', dismiss: true },
        {
          name: 'Save',
          class: BTN_PRIMARY,
          onClick: function () {
            var lb = new LoadingButton(this); lb.start();
            $.post('/api/roles/' + id + '/update/', readForm())
              .done(function (r) {
                if (r.ok) {
                  patchRow($row, r.fields);
                  Toast.show('Role updated', 'success');
                  dlg.hide();
                } else {
                  Toast.show(r.error || 'Failed', 'error');
                  lb.stop('Save');
                }
              })
              .fail(function (xhr) {
                Toast.show((xhr.responseJSON && xhr.responseJSON.error) || 'Request failed', 'error');
                lb.stop('Save');
              });
          },
        },
      ]).show();
    });
  });

  // ---------- Delete ----------
  $(document).on('click', '.role-delete-btn', function () {
    var $row = $(this).closest('tr');
    var id = $row.data('id');
    $.get('/api/roles/modal/delete/', { id: id }, function (resp) {
      if (!resp.ok) { Toast.show(resp.error || 'Failed', 'error'); return; }
      var dlg = new Dialog('Delete role', resp.html, { size: 'sm' });
      dlg.setButtons([
        { name: 'Cancel', dismiss: true },
        {
          name: 'Delete',
          class: BTN_DANGER,
          onClick: function () {
            var lb = new LoadingButton(this); lb.start();
            $.post('/api/roles/' + id + '/delete/')
              .done(function (r) {
                if (r.ok) {
                  $row.remove();
                  Toast.show('Role deleted', 'success');
                  dlg.hide();
                } else {
                  Toast.show(r.error || 'Failed', 'error');
                  lb.stop('Delete');
                }
              })
              .fail(function (xhr) {
                Toast.show((xhr.responseJSON && xhr.responseJSON.error) || 'Request failed', 'error');
                lb.stop('Delete');
              });
          },
        },
      ]).show();
    });
  });

})(jQuery);
